import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import i18n from 'locales/i18n';
import { IMerchSearch } from 'services/merch/types';
import { STATUS } from 'services/types';

registerQueryFilterLabels<IMerchSearch>('merch', {
  status: ({ value }) =>
    value !== undefined ? i18n.t(`enum.STATUS.${STATUS[value as STATUS]}`) : null,
});
